export default __webpack_public_path__ + "static/media/TransferIcon.d28c805b.svg";